<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人管理</el-breadcrumb-item>
        <el-breadcrumb-item>机器人列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <!-- 机器名查询 -->
                <el-col :span="4" >
                    <el-input placeholder="请输入编号" v-model="robotInfo.robotNo" class="m-l-30 ell-input" ></el-input>
                </el-col>
                <!-- 机器地址查询 -->
                <el-col :span="4">
                    <el-input placeholder="请输入机器名称" v-model="robotInfo.robotName" class="m-l-30 ell-input" ></el-input>
                </el-col>
                <!-- 设备是否在线 -->
                <el-col :span="4">
                   <el-select v-model="robotInfo.status" placeholder="请选择状态" class="m-l-30">
                        <el-option v-for="item in robotStatus" :key="item.value"  :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-col>
                 <!-- 设备是否在线 -->
                <el-col :span="4">
                    <el-select v-model="robotInfo.robotType" placeholder="请选择机器类型" class="m-l-30">
                            <el-option v-for="item in robotTypes" :key="item.value"  :label="item.label" :value="item.value"></el-option>
                        </el-select>
                </el-col>
                <el-col :span="4">
                        <el-date-picker v-model="robotInfo.startTimeStr"  type="date"  value-format="yyyy-MM-dd"  placeholder="选择开机日期" class="m-l-30 ell-input"> </el-date-picker>
                </el-col>
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchRobot()">查询</el-button>
                <el-button type="primary" @click="robotMethod()" v-if="roleName!='putong' && roleName!='manager'">添加机器人</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="robotList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器编号" prop="robotNo" width="300"></el-table-column>
            <el-table-column label="机器名称" prop="robotName" width="150"></el-table-column>
            <el-table-column label="机器类型"  width="100">
                  <template   slot-scope="scope">
                    <span v-if="scope.row.robotType==='2'"  >
                        安保
                    </span>
                    <span v-if="scope.row.robotType==='1'" >
                        消杀
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="开启时间" prop="startTime" width="150"></el-table-column>
            <el-table-column label="离线时间" prop="offlineTime" width="150"></el-table-column>
            <el-table-column label="状态"  width="70">
                <template   slot-scope="scope">
                    <span v-if="scope.row.status==='0'"  >
                        离线
                    </span>
                    <span v-if="scope.row.status==='1'" style="color:blue" >
                        在线
                    </span>
                    <span v-if="scope.row.status==='10'" style="color:blue" >
                        升级中
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="电量%" prop="eleQuantity"  width="80"></el-table-column>
            <el-table-column label="查看信息" prop="" width="320">
                <template slot-scope="scope">
                    <span >
                        <!-- 视频回放 -->
                        <el-tooltip effect="dark" content="视频回放" placement="top" :enterable="false"  v-if="scope.row.robotType==='2'&& scope.row.status==1">
                            <el-button type="primary" size="mini" @click="viewDialog(scope.row)">视频回放</el-button>
                        </el-tooltip>
                        <!-- 编辑按钮 -->
                        <el-tooltip effect="dark" content="工作状态" placement="top" :enterable="false"  v-if=" scope.row.status==1">
                            <el-button type="primary" size="mini" @click="WorkStatusDialog(scope.row)">工作状态</el-button>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="工作日志" placement="top" :enterable="false" >
                            <el-button type="info" size="mini" @click="jumpWorkLog(scope.row)">工作日志</el-button>
                        </el-tooltip>
                      
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" prop="" width="150" v-if="roleName!='putong'">
                <template slot-scope="scope">
                    <!-- 编辑按钮 -->
                    <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false" >
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
                    </el-tooltip>
                    <!-- 删除按钮 -->
                    <el-tooltip effect="dark" content="删除" placement="top" :enterable="false"  >  
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row.id)" ></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <!-- 添加设备对话框 -->
        <el-dialog title="添加机器人基本信息"  :visible.sync="addRobotVisible"  width="60%" @close="addRobotClose">
                <!-- 内容主题主区 -->
            <el-form ref="addRobotRef" :model="addRobot"  :rules="addRobotRules" label-width="70px">
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="机器编号:"  label-width="25" prop="robotNo">
                            <el-input v-model="addRobot.robotNo"  style="margin-left:6%" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" >
                        <el-form-item label="机器名称:"  label-width="25" prop="robotName">
                            <el-input v-model="addRobot.robotName"  style="margin-left:6%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="硬件编号:"  label-width="25" prop="hardwareNo">
                            <el-input v-model="addRobot.hardwareNo"  style="margin-left:6%"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" >
                         <el-form-item label="机器类型:"  label-width="25" prop="robotType" >
                            <el-select v-model="addRobot.robotType" placeholder="请选择"  class="el-input" style="margin-left:6%">
                                <el-option v-for="item in robotTypes" :key="item.value"  :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                        <el-form-item label="ip地址:"  label-width="25" prop="ip">
                            <el-input v-model="addRobot.ip"  style="margin-left:10%"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="10" >
                         <el-form-item label="所在机构:"  label-width="25" prop="institutionType" >
                            <el-select v-model="addRobot.institutionType" placeholder="请选择"  class="el-input" style="margin-left:6%">
                                <el-option v-for="item in institution" :key="item.value"  :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
                <!-- 底部区 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="addRobotVisible = false">取 消</el-button>
                <el-button type="primary" @click="addRobotData()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑设备对话框 -->
        <el-dialog title="修改机器人基本信息"  :visible.sync="updateRobotVisible"  width="60%" @close="updateRobotClose">
                <!-- 内容主题主区 -->
            <el-form ref="updateRobotRef" :model="updateRobot"  :rules="updateRobotRules" label-width="70px">
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="机器编号:"  label-width="25" prop="robotNo">
                            <el-input v-model="updateRobot.robotNo"  style="margin-left:6%" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" >
                        <el-form-item label="机器名称:"  label-width="25" prop="robotName">
                            <el-input v-model="updateRobot.robotName"  style="margin-left:6%"></el-input>          
                        </el-form-item>
                    </el-col>
                </el-row>
                 <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="硬件编号:"  label-width="25" prop="hardwareNo">
                            <el-input v-model="updateRobot.hardwareNo"  style="margin-left:6%" disabled></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="10" >
                         <el-form-item label="机器类型:"  label-width="25" prop="robotType" >
                            <el-select v-model="updateRobot.robotType" placeholder="请选择"  class="el-input" style="margin-left:6%"  disabled>
                                <el-option v-for="item in robotTypes" :key="item.value"  :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="ip地址:"  label-width="25" prop="ip">
                            <el-input v-model="updateRobot.ip"  style="margin-left:10%" ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10" >
                         <el-form-item label="所在机构:"  label-width="25" prop="institutionType" >
                            <el-select v-model="updateRobot.institutionType" placeholder="请选择"  class="el-input" style="margin-left:6%" disabled>
                                <el-option v-for="item in institution" :key="item.value"  :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
                <!-- 底部区 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateRobotVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateRobotData()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 编辑设备对话框 -->
        <el-dialog title="机器人工作状态"  :visible.sync="WorkStatusVisible"  width="60%" @close="WorkStatusClose" class="dialog1">
            
              <!-- 内容主题主区 -->
            <el-form ref="robotDataRef" :model="robotDataState"  label-width="80px" >
                <el-row>
                    <el-col :span="8" >
                        <el-form-item label="机器编号:" >
                            <el-input v-model="robotDataState.robotNo" class="m-l-20 ell-input" readonly></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" >
                        <el-form-item label="机器名称:"  >
                            <el-input v-model="robotDataState.robotName" class="m-l-20 ell-input"  readonly></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="8" >
                        <el-form-item label="工作状态:"  >
                            <el-input v-model="robotDataState.LinePowerStatus" class="m-l-20 ell-input"  readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row  v-if="robotType==1">
                
            </el-row>
                <el-row v-if="robotType==2">
                    <el-col :span="3" >
                        <el-form-item label="pm2.5:" v-if="robotData.pm2_5 >100 " >
                            <span style="color:red"> {{robotData.pm2_5}}</span>
                        </el-form-item>
                        <el-form-item label="pm2.5:" v-if="robotData.pm2_5 <=100 ">
                             <span >{{robotData.pm2_5}} </span>
                        </el-form-item>
                         <el-form-item label="pm2.5:" v-if=" robotData.pm2_5==undefined">
                             <span >暂无数据</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="pm10:"  v-if="robotData.pm10 >100 ">
                            <span style="color:red"> {{robotData.pm10}} </span>
                        </el-form-item>
                        <el-form-item label="pm10:"  v-if="robotData.pm10 <=100 ">
                            <span> {{robotData.pm10}} </span>
                        </el-form-item>
                        <el-form-item label="pm10:"  v-if="robotData.pm10 ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="湿度:"  v-if="robotData.humidity >100 ">
                            <span style="color:red"> {{robotData.humidity}} </span>
                        </el-form-item>
                        <el-form-item label="湿度:"  v-if="robotData.humidity <=100 ">
                            <span> {{robotData.humidity}} </span>
                        </el-form-item>
                        <el-form-item label="湿度:"  v-if="robotData.humidity ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                       <el-form-item label="温度:"  v-if="robotData.temperature >100 ">
                            <span style="color:red"> {{robotData.temperature}} </span>
                        </el-form-item>
                        <el-form-item label="温度:"  v-if="robotData.temperature <=100 ">
                            <span> {{robotData.temperature}} </span>
                        </el-form-item>
                        <el-form-item label="温度:"  v-if="robotData.temperature ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                     <el-col :span="3" >
                        <el-form-item label="大压:"  v-if="robotData.baro >100 ">
                            <span style="color:red"> {{robotData.baro}} </span>
                        </el-form-item>
                        <el-form-item label="大压:"  v-if="robotData.baro <=100 ">
                            <span> {{robotData.baro}} </span>
                        </el-form-item>
                        <el-form-item label="大压:"  v-if="robotData.baro ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="光照:"  v-if="robotData.illumination >100 ">
                            <span style="color:red"> {{robotData.illumination}} </span>
                        </el-form-item>
                        <el-form-item label="光照:"  v-if="robotData.illumination <=100 ">
                            <span> {{robotData.illumination}} </span>
                        </el-form-item>
                        <el-form-item label="光照:"  v-if="robotData.illumination ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="挥发性:"  v-if="robotData.tvoc >100 ">
                            <span style="color:red"> {{robotData.tvoc}} </span>
                        </el-form-item>
                        <el-form-item label="挥发性:"  v-if="robotData.tvoc <=100 ">
                            <span> {{robotData.tvoc}} </span>
                        </el-form-item>
                        <el-form-item label="挥发性:"  v-if="robotData.tvoc ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="co2:"  v-if="robotData.co2 >100 ">
                            <span style="color:red"> {{robotData.co2}} </span>
                        </el-form-item>
                        <el-form-item label="co2:"  v-if="robotData.co2 <=100 ">
                            <span> {{robotData.co2}} </span>
                        </el-form-item>
                        <el-form-item label="co2:"  v-if="robotData.co2 ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="robotType==2" >
                    <el-col :span="3" >
                        <el-form-item label="臭氧:"  v-if="robotData.o3 >100 ">
                            <span style="color:red"> {{robotData.o3}} </span>
                        </el-form-item>
                        <el-form-item label="臭氧:"  v-if="robotData.o3 <=100 ">
                            <span> {{robotData.o3}} </span>
                        </el-form-item>
                        <el-form-item label="臭氧:"  v-if="robotData.o3 ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="硫化氢:"  v-if="robotData.h2s >100 ">
                            <span style="color:red"> {{robotData.h2s}} </span>
                        </el-form-item>
                        <el-form-item label="硫化氢:"  v-if="robotData.h2s <=100 ">
                            <span> {{robotData.h2s}} </span>
                        </el-form-item>
                        <el-form-item label="硫化氢:"  v-if="robotData.h2s ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="一氧化碳:"  v-if="robotData.co >100 ">
                            <span style="color:red"> {{robotData.co}} </span>
                        </el-form-item>
                        <el-form-item label="一氧化碳:"  v-if="robotData.co <=100 ">
                            <span> {{robotData.co}} </span>
                        </el-form-item>
                        <el-form-item label="一氧化碳:"  v-if="robotData.co ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="二氧化硫:"  v-if="robotData.so2 >100 ">
                            <span style="color:red"> {{robotData.so2}} </span>
                        </el-form-item>
                        <el-form-item label="二氧化硫:"  v-if="robotData.so2 <=100 ">
                            <span> {{robotData.so2}} </span>
                        </el-form-item>
                        <el-form-item label="二氧化硫:"  v-if="robotData.so2 ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                     <el-col :span="3"  >
                        <el-form-item label="甲醛:"  v-if="robotData.hcho >100 ">
                            <span style="color:red"> {{robotData.hcho}} </span>
                        </el-form-item>
                        <el-form-item label="甲醛:"  v-if="robotData.hcho <=100 ">
                            <span> {{robotData.hcho}} </span>
                        </el-form-item>
                        <el-form-item label="甲醛:"  v-if="robotData.hcho ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                     <el-col :span="3" >
                        <el-form-item label="氨气:"  v-if="robotData.nh4 >100 ">
                            <span style="color:red"> {{robotData.nh4}} </span>
                        </el-form-item>
                        <el-form-item label="氨气:"  v-if="robotData.nh4 <=100 ">
                            <span> {{robotData.nh4}} </span>
                        </el-form-item>
                        <el-form-item label="氨气:"  v-if="robotData.nh4 ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3" >
                        <el-form-item label="噪音:"  v-if="robotData.noise >100 ">
                            <span style="color:red"> {{robotData.noise}} </span>
                        </el-form-item>
                        <el-form-item label="噪音:"  v-if="robotData.noise <=100 ">
                            <span> {{robotData.noise}} </span>
                        </el-form-item>
                        <el-form-item label="噪音:"  v-if="robotData.noise ==undefined ">
                            <span> 暂无数据 </span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-row :gutter='20' >
                 <el-col >
                    <span style="font-size:25px;color:blue;float:left;padding-right:50px">地图编号: {{this.mapNo}}</span>
                </el-col>
            </el-row>
            <el-row :gutter='20' >
                <el-col :span="14">
                    <canvas id="mycanvas" class="mycanvasDiv" alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                </el-col>
            </el-row>
           
        </el-dialog>
     
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="robotInfo.pageNum"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
    </el-card >
  </div>
</template>

<script>
import mqtt from 'mqtt'
import { MQTT_SERVICE, MQTT_USERNAME } from './sysconstant'
import { mapState } from 'vuex'
export default {
  name: 'robot',
  data(){
      var checkZF=(rule,value,cb)=>{
            var zF = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(!zF.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
      }
      var checkRobotNo=(rule,value,cb)=>{
            const  regrobotNo=/^[0-9a-zA-Z]*$/
            if(regrobotNo.test(value)){
                return cb();
            }
            cb(new Error('请输入数字或字母!'))
      }

      var checkIp=(rule,value,cb)=>{
            const  regIp=/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
            if(!regIp.test(value)&& value != ''){
                cb(new Error('请输入正确的IP!'))
            }
            return cb();
      }


      return {
          addRobot:{
              robotNo:'',
              robotName:'',
              hardwareNo:'',
              robotType:'',
              ip:'',
              institutionType:''
          },
          updateRobot:{
              robotNo:'',
              robotName:''
          },
          updateRobotRules:{
            robotNo:[{required: true, message: '请输入机器编号!',  trigger: 'blur' },{ min: 10,  max: 36,  message: '长度在 10 到 36 个字符!',   trigger: 'blur' }],
            robotName:[{required: true, message: '请输入机器名称!',  trigger: 'blur' },{ min: 6,  max: 16,  message: '长度在 6 到 16 个字符!',   trigger: 'blur' } ,{ validator : checkZF, trigger: 'blur'}],
             ip:[{required: true, message: '请输入IP!',  trigger: 'blur' },,{ validator : checkIp, trigger: 'blur'}],
          },
          addRobotRules:{
            robotNo:[{required: true, message: '请输入机器编号!',  trigger: 'blur' },{ min: 10,  max: 36,  message: '长度在 10 到 36 个字符!',   trigger: 'blur' },{ validator : checkRobotNo, trigger: 'blur'}],
            robotName:[{required: true, message: '请输入机器名称!',  trigger: 'blur' },{ min: 6,  max: 16,  message: '长度在 6 到 16 个字符!',   trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
            hardwareNo:[{required: true, message: '请输入硬件编号!',  trigger: 'blur' },{ min: 6,  max: 16,  message: '长度在 6 到 16 个字符!',   trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
            robotType:[{required: true, message: '请选择机器人类型!',  trigger: 'blur' }],
            ip:[{required: true, message: '请输入IP!',  trigger: 'blur' },,{ validator : checkIp, trigger: 'blur'}],
            institutionType:[{required: true, message: '请选择所属机构!',  trigger: 'blur' }],
          },
          addRobotVisible:false,
          updateRobotVisible:false,
          WorkStatusVisible:false,
          robotInfo :{
              robotNo:'',
              robotName:'',
              status:'',
              startTimeStr:'',
              robotType:'',
               pageNum: 1
          },
          robotType:'',
          robotData:{
            mapPngUrl: null,
            roadUrl: null,
            resolution: '',
            origin_x: '',
            origin_y: '',
            imageWidth: '',
            imageHeight: '',
            //点集
            dotList: [],
            //线集
            lineList: [],
            gcanvas: null,
            timer: null,
            globleY: 0,
            LineCount:"0"
          },
          robotDataState:{
            robotNo:'',
            robotName:'',
            LineCount:"0",
            LinePowerStatus:'闲置',
            elevatorPosition:'',
          },
          total:0,
          viewRobotWorking:null,
          robotStatus:[
             {
                value: '0',
                label: '离线'
            }, {
                value: '1',
                label: '在线'
            }
          ],
          robotTypes:[
             {
                value: '1',
                label: '消杀'
            },{
                value: '2',
                label: '安保'
            }
          ],
          institution:[
             {
                value: '1',
                label: '本部'
            },{
                value: '2',
                label: '创慧'
            }
          ],
          roleName:'',
          robotList:[],
          clientId:'',
          user:'',
          topic:'',
          client:null,
          mapNo:'',
      }
  },
   //生命周期函数
  created(){
     this.getStorage();
     this.searchRobot();
     this.initMqttClient()
  },
  computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
  methods:{
        //跳转到工作日志
        jumpWorkLog(obj){
             this.$router.replace({path: '/workWarn?robotNo='+obj.robotNo+'&pageFlag='+"2"});
        },
        //初始化mqttClient
        initMqttClient(){
            if(this.mqttClient==null){
                 this.$store.dispatch('mqttServer')
            }
        },
        init(){
            let robotType= this.viewRobotWorking.robotType
            let topic=''
            if(robotType=="1"){
                topic="/Unione/DisinfectInfo/"+this.robotData.robotNo
            }else{
                topic="/Unione/AirQuality/"+this.robotData.robotNo
            } 
            this.topic=topic;
            try {
                this.mqttClient.subscribe(topic, { qos: 0 }, (error) => {
                    window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功:'+topic)
                    if (!error) {
                        console.log('订阅成功')
                    } else {
                        console.log('订阅失败')
                    }
                })
            } catch (e) {
              var subscribe=window.sessionStorage.getItem('subscribe')
                if(subscribe*1===1){
                    this.$message.error("网络差,退出重新登录!");
                    return this.$router.push('/login') 
                }else{
                    window.sessionStorage.setItem("subscribe",1)
                    this.$store.dispatch('mqttServer')
                    location.reload()
                    return 
                }
                
            }
            let that=this
            // 接收消息处理
            this.mqttClient.on('message', (topic, message) => {
                var data =JSON.parse(message);
                if(robotType === "1"){
                    //console.log(data)
                    var  plus_count=data.plus_count
               
                    that.robotDataState.LineCount=plus_count;
                    
                    var  uv_work_state=data.uv_work_state
                    
                    if( uv_work_state==="1"){
                      
                        that.robotDataState.LinePowerStatus="工作";
                    }else{
                       
                        that.robotDataState.LinePowerStatus="闲置";
                    }
                    var  uv_pos=data.uv_pos
                   
                    if(uv_pos=="0"){
                       
                        that.robotDataState.elevatorPosition="下面";
                    }
                    if(uv_pos==="2"){
                        
                        that.robotDataState.elevatorPosition="中间";  
                    }
                    if(uv_pos==="1"){
                        that.robotDataState.elevatorPosition="上面";  
                    }
                    //console.log( that.robotDataState)
                }else{
                    that.robotData.pm2_5=parseInt(data.pm2_5);
                    that.robotData.pm10=parseInt(data.pm10);
                    that.robotData.humidity=parseInt(data.humidity);
                    that.robotData.temperature=parseInt(data.temperature);
                    that.robotData.baro=parseInt(data.baro);
                    that.robotData.illumination=parseInt(data.illumination);
                    that.robotData.tvoc=parseInt(data.tvoc);
                    that.robotData.co2=parseInt(data.co2);
                    that.robotData.hcho=parseInt(data.hcho);
                    that.robotData.o3=parseInt(data.o3);
                    that.robotData.h2s=parseInt(data.h2s);
                    that.robotData.co=parseInt(data.co);
                    that.robotData.so2=parseInt(data.so2);
                    that.robotData.nh4=parseInt(data.nh4);
                    that.robotData.noise=parseInt(data.noise);
                }
                var x = (parseFloat(data.pos_x) - that.origin_x) / that.resolution
                var y = that.imageHeight - (parseFloat(data.pos_y) - that.origin_y) / that.resolution
                //console.log(x, y, that.origin_x, that.resolution, that.imageHeight)
                that.globleX = x
                that.globleY = y
                that.updateCanvas();
            })
        },
        unsubscribe: function() {  
            this.mqttClient.unsubscribe(  
                    this.topic, err => {  
                    console.log(err || '取消订阅成功');  
                }  
            );  
        },  
        viewDialog(obj){
            if(obj.status==0){
                  return this.$message.error("机器人不在线!");
            }
            if(obj.status==3){
                  return this.$message.error("机器人升级中!");
            }
            this.$http.get('robot/getRobotDetail',{params :{ id :  obj.id }}) .then(response => {
                let result=response.data.result; 
                if(result.status==0){
                    this.$message.error("机器人不在线!");
                    return ;
                }
                this.$router.push('/viewVideo?No='+response.data.result.ysNo) 
            })
        },
        IssueDataMap(obj){
            this.$router.replace({path: '/dataMap?robotNo='+obj.robotNo})
        },
        IssueTemporary(obj){
            this.$router.replace({path: '/TemporaryMap?robotNo='+obj.robotNo})
        },
        WorkStatusDialog(obj){  
             if(obj.status==0){
                  return this.$message.error("机器人不在线!");
             }
             if(obj.status==3){
                  return this.$message.error("机器人升级中!");
             }
             this.viewRobotWorking=obj
             var that=this
             this.$http.get('robot/getRobotDetail',{params :{ id :  obj.id }})
             .then(response => {
                    if (response.data.code === 200) {
                        that.mapNo=obj.scene;
                        that.WorkStatusVisible=true;
                        that.robotData=response.data.result
                        that.robotType=response.data.result.robotType
                        if(that.robotType=="1"){
                            if(that.robotData.LineCount ==undefined){
                                    that.robotDataState.robotNo=that.robotData.robotNo
                                    that.robotDataState.robotName=that.robotData.robotName
                                    that.robotDataState.LineCount="0";
                                    that.robotDataState.LinePowerStatus="闲置";
                                    that.robotDataState.elevatorPosition="下面";
                            }
                            if(that.WorkStatusVisible ){
                                if(response.data.result.orginUrl==undefined){
                                    that.$message.error("未查询到正在使用的地图信息!");
                                    return that.WorkStatusVisible=false;
                                }
                                that.downloadOFile(response.data.result.orginUrl)
                            }
                        } 
                        if(that.robotType=="2"){
                            
                        }
                    }else{
                        return that.$message.error(res.message);
                    }
                }).catch(failResponse => {
                
             })
        },
      
         // 下载原点文件
        downloadOFile(url) {
        console.log('下载原点文件', url)
         this.$http.get(window.location.origin+url)
            .then(res => {
                console.log(res)
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                that.origin_y = originArr[1]
                console.log(that.robotData.mapPngUrl)
                that.doDraw(that.robotData.mapPngUrl)
            }  
            }).catch(res => {
                
            })
         },
        // imageUrl为后台提供图片地址
        doDraw(imageUrl) {
            // 获取canvas
            var canvas = document.getElementById('mycanvas')
            // 由于弹窗，确保已获取到
            var a = setInterval(() => {
            // 重复获取
                canvas = document.getElementById('mycanvas')
                if (!canvas) {
                return false
                } else {
                clearInterval(a)
                // 可以理解为一个画笔，可画路径、矩形、文字、图像
                var context = canvas.getContext('2d')
                var scale = window.devicePixelRatio
                context.scale(scale, scale)
                var img = new Image()
                img.src = imageUrl
                const that = this
                // 加载图片
                img.onload = function() {
                    if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    canvas.setAttribute('width', img.width)
                    canvas.setAttribute('height', img.height)
                    that.imageWidth = canvas.width
                    that.imageHeight = canvas.height
                    that.gcanvas = canvas
                    // 绘制图片
                    context.drawImage(img, 0, 0, img.width, img.height)
                    //起始点坐标计算公式
                    var x1 = (0 - that.origin_x) / that.resolution
                    console.log(x1)
                    var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                    console.log(y1)
                    //画出原点坐标
                    that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                    that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                    //画轨迹
                    that.downloadRoadFile(that.robotData.roadUrl)
                    }
                  }
                }
            }, 10)
        },
    // 画线doDra
    doDrawLine(context, x1, y1, x2, y2, color, line) {
      context.beginPath()
      context.moveTo(x1, y1)
      context.lineTo(x2, y2)
      context.strokeStyle = color
      context.lineWidth = line
      context.stroke()
    },
    //根据轨迹文件画图
    downloadRoadFile(url) {
        const that = this
        console.log('加载xml文件')
          this.$http.get(window.location.origin+url)
            .then(res => {
                    const blob = new Blob([res.data])
                    const reader = new FileReader()
                    
                    reader.readAsText(blob, 'utf-8')
                    reader.onload = function() {
                    //解析  
                    var map = that.$x2js.xml2js(reader.result)  
                    var xmlList = map.map.vertex
                    var lineXmlList = map.map.edge
                    var tempList = []
                    var lineist = []
                    for (var i = 0; i < xmlList.length; i++) {
                        var tempString = xmlList[i]
                        var Id = tempString._id
                        var X = tempString._x
                        var Y = tempString._y
                        tempList.push({ Id, X, Y })
                    }
                    if(lineXmlList.length===undefined){
                            var lineString = lineXmlList
                            var lid = lineString._id
                            var src_id = lineString._src_id
                            var dst_id = lineString._dst_id
                            lineist.push({ lid, src_id, dst_id })
                    }else{
                        for (var k = 0; k < lineXmlList.length; k++) {
                            var lineString = lineXmlList[k]
                            var lid = lineString._id
                            var src_id = lineString._src_id
                            var dst_id = lineString._dst_id
                            lineist.push({ lid, src_id, dst_id })
                        }
                    }
                    that.robotData.dotList = tempList
                    that.robotData.lineList = lineist

                   
                    for (var l = 0; l < tempList.length; l++) {
                        var context = that.gcanvas.getContext('2d')
                        var x1 = parseFloat(that.robotData.dotList[l].X)
                        var y1 = parseFloat(that.robotData.dotList[l].Y)
                        x1 = (x1 - that.origin_x) / (that.resolution*1)
                        y1 = that.imageHeight - (y1 - that.origin_y) / (that.resolution*1)
                        console.log(x1+";"+y1)
                        that.doDrawSicle(context, x1, y1, 'green', 3,l)
                    }
                    for (var j = 0; j < lineist.length; j++) {
                        var context1 = that.gcanvas.getContext('2d')
                        var m = parseInt(lineist[j].src_id)
                        var n = parseInt(lineist[j].dst_id)
                        var x = parseFloat(that.robotData.dotList[m].X)
                        var y = parseFloat(that.robotData.dotList[m].Y)
                        x = (x - that.origin_x) / that.resolution
                        y = that.imageHeight - (y - that.origin_y) /(that.resolution*1)
                        var x2 = parseFloat(that.robotData.dotList[n].X)
                        var y2 = parseFloat(that.robotData.dotList[n].Y)
                        x2 = (x2 - that.origin_x) / that.resolution
                        y2 = that.imageHeight - (y2 - that.origin_y) / (that.resolution*1)
                        that.doDrawLine(context1, x, y, x2, y2, 'blue', 2)
                    }
                   
                   
                }
            }).catch((error) => {
                console.log(error)
            })
            //开启订阅
            this.init();
        },
        //实时重新更新地图
        updateCanvas() {
            var that = this
            var context = that.gcanvas.getContext('2d')
            var scale = window.devicePixelRatio
            context.scale(scale, scale)
            var img = new Image()
            img.src = this.robotData.mapPngUrl
            // 加载图片
            img.onload = function() {
                if (img.complete) {
                // 根据图像重新设定了canvas的长宽
                that.gcanvas.setAttribute('width', img.width)
                that.gcanvas.setAttribute('height', img.height)
                that.imageWidth = img.width
                that.imageHeight = img.height
                // 绘制图片
                context.drawImage(img, 0, 0, img.width, img.height)
                var x1 = (0 - that.origin_x) / that.resolution
                var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                for (var j = 0; j < that.robotData.lineList.length; j++) {
                    var m = parseInt(that.robotData.lineList[j].src_id)
                    var n = parseInt(that.robotData.lineList[j].dst_id)
                    var x = parseFloat(that.robotData.dotList[m].X)
                    var y = parseFloat(that.robotData.dotList[m].Y)
                    x = (x - that.origin_x) / that.resolution
                    y = that.imageHeight - (y - that.origin_y) / that.resolution
                    var x2 = parseFloat(that.robotData.dotList[n].X)
                    var y2 = parseFloat(that.robotData.dotList[n].Y)
                    x2 = (x2 - that.origin_x) / that.resolution
                    y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                    that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                }
                for (var l = 0; l < that.robotData.dotList.length; l++) {
                    var x3 = parseFloat(that.robotData.dotList[l].X)
                    var y3 = parseFloat(that.robotData.dotList[l].Y)
                    x3 = (x3 - that.origin_x) / that.resolution
                    y3 = that.imageHeight - (y3 - that.origin_y) / that.resolution
                    that.doDrawSicle(context, x3, y3, 'green', 3,l)
                }
                var robotImage = new Image()
                //robotImage.src = roboticon
                that.doDrawSiclePath(context, that.globleX, that.globleY, 'red', 3)
                }
            }
        },
        //机器人原点
        doDrawSiclePath(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line,index) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.font="15px lighter arial";
            context.fillText(index,x,y);
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 关闭详情弹框
        handleClose() {
        
        },
        //更新
        updateRobotData(){
            this.$refs.updateRobotRef.validate(valid  => {
                if (valid){
                        this.$http.get('robot/updateRobot',{params :{ id :  this.updateRobot.id,robotName : this.updateRobot.robotName,ip : this.updateRobot.ip}})
                                    .then(response => {
                                            if (response.data.code === 200) {
                                                this.$message.success(response.data.message);
                                                this.updateRobotVisible=false;
                                                this.searchRobot();
                                            }else{
                                                return this.$message.error(response.data.message);
                                            }
                            }).catch(failResponse => {
                                        
                        })
                }else{
                    return false;
                }
            })
            

        },
        updateRobotClose(){
            this.$refs.updateRobotRef.resetFields();
        },
        WorkStatusClose(){
            this.robotData.robotNo=''
            this.robotData.robotName=''
            this.robotData.mapPngUrl=null
            this.robotData.roadUrl=null
            this.robotData.resolution=''
            this.robotData.origin_x=''
            this.robotData.origin_y=''
            this.robotData.imageWidth=''
            this.robotData.imageHeight=''
            this.robotData.dotList=[]
            this.robotData.lineList=[]
            this.robotData.gcanvas=null
            this.robotData.globleX=0
            this.robotData.globleY=0
            this.clearCanvas();
            if(this.mqttClient!=='' && this.mqttClient!==null){
                this.unsubscribe()
                //this.unconnect()
            }
        },
        //点击指定页码跳转
        handleCurrentChange(page){
            this.robotInfo.pageNum=page;
            this.searchRobot();
        },
        showEditDialog(obj){
            this.updateRobotVisible=true;
            this.$http.get('robot/getRobotById',{params :{ id :  obj }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.updateRobot=response.data.result
                      
                    }else{
                        return this.$message.error(res.message);
                    }
                }).catch(failResponse => {
                
            })
        },
        //获取缓存信息
        getStorage(){
            var  role =this.$cookies.get("role")
            if(role!==null && role!==undefined  ){
                this.roleName= role.name;
            }else{
                return this.$router.push('/login') 
            }
        },
        addRobotData(){
            this.$refs.addRobotRef.validate(valid => {
                if (valid) {
                    this.$http.get('/robot/addRobot',{params :{ robotName : this.addRobot.robotName,robotNo : this.addRobot.robotNo,hardwareNo : this.addRobot.hardwareNo,robotType:this.addRobot.robotType,ip:this.addRobot.ip,institutionType:this.addRobot.institutionType}})
                    .then(response => {
                            if (response.data.code === 200) {
                                this.addRobotVisible=false;
                                this.searchRobot();
                                return this.$message.success("更新成功!");
                            }else{
                                return this.$message.error(response.data.message);
                            }
                        }).catch(failResponse => {

                    })
                } else {
                    return false;
                }
            })
            
        },
        robotMethod(){
            this.addRobotVisible =true
        },
        addRobotClose(){
             this.$refs.addRobotRef.resetFields();
        },
        clearParams(){
          this.robotInfo.robotNo='';
          this.robotInfo.robotName='';
          this.robotInfo.status='';
          this.robotInfo.robotType='';
          this.robotInfo.startTimeStr='';
        },
        clearCanvas(){
            var c=document.getElementById("mycanvas");
            var cxt=c.getContext("2d");
            cxt.clearRect(0,0,c.width,c.height);
        },
        searchRobot(){
            var check = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.robotInfo.robotNo)||check.test(this.robotInfo.robotNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.$http.post('/robot/selectRobot',JSON.stringify(this.robotInfo))
            .then(response => {
                    if (response.data.code === 200) {
                        this.robotList=response.data.result.data
                        this.total=response.data.result.total
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
         //根据id删除
      async deleteById(id){
          //弹框询问
         const confirmRes= await this.$confirm('此操作将永久该机器, 是否继续?', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
         }).catch(err =>{
             return err
         })
         if(confirmRes !=='confirm'){
             return this.$message.info('已经取消删除')
         }
         this.$http.get('/robot/deleteRobot',{params :{ id :  id }})
         .then(response => {
                if (response.data.code === 200) {
                    this.$message.success("删除成功!");
                    this.searchRobot();
                }else{
                     return this.$message.error(response.data.msg);
                }
            }).catch(failResponse => {

        })
      },
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.elll-input {
    width: 150px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.m-l-20 {
  margin-left: 20px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
.dialog1 {
    font-weight: bold;
    align-content: center;
    margin:auto;
}
 
</style>


// WEBPACK FOOTER //
// src/components/robot/Robot.vue